import {Shift} from '@app/core/models/shift.model';
import {Department} from '@app/core/models/department.model';
import {IUserTotalCalcWithDepartment} from '@app/core/interfaces/salary';

export interface IActionsCount {
	amount_of_availabilities: number;
	amount_of_pending_shifts: number;
	amount_of_shift_exchange: number;
	amount_of_shift_requests: number;
}

export interface IPunchStatus {
	departments: Department[];
	punched_in: boolean;
	shift: Shift;
}

export interface IPunchSettings {
	can_user_punch: number;
	departments: Department[];
	punch_clock_enabled: number;
}

export interface IWeather {
	type: string[];
	temperature: number;
	humidity: number;
	pressure: number;
	country_code: string;
	postal_code: string;
	open_weather_map_id: number;
	city: string;
}

export interface IDashboardState {
	isLoading: boolean;
	nextShifts: Shift[];
	punchSettings: IPunchSettings;
	actionsCount: IActionsCount;
	punchStatus: IPunchStatus;
	userSalaryCalculation: IUserTotalCalcWithDepartment;
	availableShifts: Shift[];
	weather: IWeather[];
}

export const initialDashboardState: IDashboardState = {
	isLoading: false,
	nextShifts: [],
	punchSettings: undefined,
	actionsCount: undefined,
	punchStatus: undefined,
	availableShifts: [],
	userSalaryCalculation: undefined,
	weather: [],
};
